<template>
	<v-dialog
		v-model="dialogOtp"
		max-width="520"
		persistent
	>
		<v-card>
			<v-card-text class="d-flex align-center justify-space-between py-4">
				<h3 class="">Kode OTP Keamanan</h3>
				<v-btn
					icon
					@click="cancelSaveDialog"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-text>
			<v-card-text>
				<v-row>
					<v-col cols="12" class="text-center font-weight-bold mb-2">
						Masukkan 6 digit kode keamanan yang dikirim<br>melalui pesan WA Anda.
					</v-col>

					<v-col cols="12" class="text-center mb-2 px-5 col-otp">
						<v-alert
							dense
							text
							:type="(!otpError) ? 'success' : 'error'"
							class="mb-50 text-left"
							transition="scale-transition"
							v-if="otpMessage !== ''"
						>
							{{ otpMessage }}
						</v-alert>

						<v-row class="px-5">
							<v-col cols="2 px-1">
								<v-text-field ref="otp0" v-model="otp[0]" @input="moveToNextField(0)" outlined autofocus  x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
							</v-col>
							<v-col cols="2 px-1">
								<v-text-field ref="otp1" v-model="otp[1]" @input="moveToNextField(1)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
							</v-col>
							<v-col cols="2 px-1">
								<v-text-field ref="otp2" v-model="otp[2]" @input="moveToNextField(2)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
							</v-col>
							<v-col cols="2 px-1">
								<v-text-field ref="otp3" v-model="otp[3]" @input="moveToNextField(3)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
							</v-col>
							<v-col cols="2 px-1">
								<v-text-field ref="otp4" v-model="otp[4]" @input="moveToNextField(4)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
							</v-col>
							<v-col cols="2 px-1">
								<v-text-field ref="otp5" v-model="otp[5]" @input="moveToNextField(5)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
							</v-col>
						</v-row>
					</v-col>

					<v-col cols="12" class="text-center mb-2 px-5">
						<p class="mb-0">Belum menerima kode OTP?</p>
						<Timer :valDate="new Date(otpLastSent)" @action="changeTimer" class="font-weight-bold font-size-16 py-2" v-show="(this.otpCount == '1')"></Timer>
						<v-btn 
							text
							tile
							color="primary"
							class="py-0"
							:disabled="(this.otpCount == '1')"
							@click="getNewOTPCode"><v-icon dense class="mr-1">mdi-refresh</v-icon>Kirim Ulang Kode OTP</v-btn>
					</v-col>

					<v-col cols="12" class="text-center mb-2 px-5">
						<v-btn
							rounded
							color="primary"
							:loading="btnLoadingProses"
							:disabled="(otp.join('').length < 6) ? true : false"
							@click="verifyInputOTP"
						>
							Proses Kirim Serial
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Timer from './Timer';

export default {
	components: { Timer },
	data () {
		return {
			dialogOtp: false,
			otp: [],
			otpError: false,
			otpMessage: '',
			otpCount: '',
			otpLastSent: null,
			otpTimer: null,
			loadign_otp_process: false,
			member_otp_code: '',
			btnLoadingProses: false,
		}
	},
	computed: {
		...mapState('autentikasi', ['userData']),
	},
	methods: {
		...mapActions('serial', ['getNewOTP', 'verifyOTP']),

		changeTimer(val) {
			this.otpCount = val
		},
		modalHide() {
			this.dialogOtp = false
		},
		loadingButton() {
			this.btnLoadingProses = true
		},
		async modalShow() {
			this.dialogOtp = await true
			this.member_otp_code = await ''
			this.otp = await []
			this.otpMessage = await ''
			this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
			this.getNewOTPCode()
			this.otpError = false
		},

		getNewOTPCode() {
			if (this.otpCount == '' || this.otpCount == '0') {
				this.btnLoadingProses = true
				let params = {
					username: this.userData.member_network_code,
					type: 'serial'
				}
				this.getNewOTP(params)
					.then(()=> {
						this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
						this.otpMessage = 'Kode otp keamanan telah berhasil dikirimkan.'
						this.otpError = false
						setTimeout(() => {
							this.otpMessage = ''
						}, 6000);
						this.btnLoadingProses = false
					})
					.catch((err) => {
						this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
						this.otpMessage = (err.data.message !== undefined) ? err.data.message : ''
						this.otpError = true
						this.btnLoadingProses = false
					})
			}
		},

		moveToNextField(index) {
      const nextIndex = index + 1
      if (this.$refs['otp' + nextIndex] !== undefined) this.$refs['otp' + nextIndex].focus()
    },

		cancelSaveDialog() {
			this.otpMessage = ''
			this.otpError = false
			this.otp = []
			this.dialogOtp = false
			this.btnLoadingProses = false
		},

		async verifyInputOTP() {
			this.btnLoadingProses = await true
				let params = {
					username: this.userData.member_network_code,
					otp: this.otp.join('')
				}
				this.verifyOTP(params)
					.then(()=> {
						// this.btnLoadingProses = false
						this.$emit('action', this.otp.join(''))
					})
					.catch(() => {
						this.btnLoadingProses = false
					})
		}

		// this.$emit('action')
	},

	mounted() {
		
	},
};
</script>